import { UTM_MARKS } from 'constants/utmMarks';

export const getUtmMarksFromQuery = (ctx: App.ReduxAppContext['ctx']) => {
  const { query = {} } = ctx;

  return Object.values(UTM_MARKS).reduce<Record<string, string>>((prev, name) => {
    const value = query[name] ? String(query[name]) : undefined;
    if (value) {
      prev[name] = value;
    } else {
      prev[name] = UTM_MARKS.medium === name ? '(none)' : '(not set)';
    }
    return prev;
  }, {});
};
